import { getListOfLevels } from "../util/ColorHelper";
import { legendItemStyle, legendStyle } from "../legends/style";
import { mapFillColorStrategy } from "./MapConstants";
import { getValueToIconMapForHazard } from "../map/HazardSelectorHelper";
import { getValueToIconMapForKPI } from "../map/KPISelectorHelper";

const languageOfChoice = (objectWithKeysItAndEn) => {
  // If missing, use English.
  // The object is supposed to have keys "it" and "en", and it might come from an external file.
  const correctChoice = objectWithKeysItAndEn[localStorage.getItem("language")];
  if (correctChoice) {
    return correctChoice;
  } else {
    return objectWithKeysItAndEn["en"];
  }
};

export const comparisonSymbol = (index, length) => {
  if (index === 0) {
    return "<=";
  }
  if (index === length - 1) {
    return ">=";
  } else {
    return "==";
  }
};

const createLegendItems = (json, geojson) => {
  const listOfLevels =
    json.strategy === mapFillColorStrategy.interpolate ? getListOfLevels(json, geojson) : null;

  return json.colorList.map((color, index) => (
    <div key={index}>
      <span style={legendItemStyle(color)}></span>
      {languageOfChoice(json.colorText)[index] +
        (json.strategy === mapFillColorStrategy.interpolate
          ? " (" +
            comparisonSymbol(index, json.colorList.length) +
            " " +
            listOfLevels.legendLevels[index].level +
            ")"
          : "")}
    </div>
  ));
};

export const LegendHelper = (props) => {
  const { json, geojson, currentZoom, extraObject, filteredMapDataProp } = props;

  if (!json || !geojson) {
    return null;
  }

  if (currentZoom < json.minzoom || currentZoom >= json.maxzoom) {
    return null;
  }

  let extraText;
  if (extraObject) {
    const { hazardSelectDone, KPISelectDone } = extraObject;
    if (hazardSelectDone && KPISelectDone) {
      // extraText =
      //   " ( " +
      //   getValueToIconMapForHazard(hazardSelectDone).text +
      //   ", " +
      //   getValueToIconMapForKPI(KPISelectDone, props.variantProp).text +
      //   ")";

      const hazardIconAndText = getValueToIconMapForHazard(hazardSelectDone);
      extraText = ` ( ${hazardIconAndText.text}. ${hazardIconAndText.extraHazardText ? hazardIconAndText.extraHazardText + "," : ""} ${getValueToIconMapForKPI(KPISelectDone, props.variantProp).text} )`;
    }
  }

  if (!extraObject && filteredMapDataProp && filteredMapDataProp.mapComuneIstatNumberToKPIValue) {
    // Note: These numbers (1,3) are assigned in cys-realerisk-sftp-py-service\services\buildingsDb_multi.py, see "000001" and "000003" in the file.
    const rma = filteredMapDataProp.mapComuneIstatNumberToKPIValue[1];
    const ita = filteredMapDataProp.mapComuneIstatNumberToKPIValue[3];

    if (rma) extraText = " RMA: " + rma + " " + languageOfChoice(json.legendWithoutAddresses) + "\n";
    if (ita) extraText += " ITA: " + ita + " " + languageOfChoice(json.legendWithoutAddresses) + "\n";
    if (extraText) extraText += "\n";
  }
  return (
    <div style={legendStyle}>
      <div>
        <b>{languageOfChoice(json.legendTitle)}</b>
      </div>
      {createLegendItems(json, geojson)}
      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "x-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
            whiteSpace: "pre-line",
          }}
        >
          {(extraText ? extraText : "") + languageOfChoice(json.legendFootnote)}
        </span>
      </div>
      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "xx-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          {languageOfChoice(json.legendLicense)}
        </span>
      </div>
    </div>
  );
};
